import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { URLS, STORAGE, INSIDERODEO_EVENT_STORAGE, APPLICATION_GLOBAL_SLUG, MODAL_NAME } from "src/_config";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { SOCKET_CHANNEL, RODEO_PAGE_NAME } from "src/_config";
// import GuestSaveVoteModal from "../events/modal/guestSaveVoteModal";
// import StatusModal from "../events/modal/statusModal";
import CouponModal from "../events/modal/couponModal";
import UpdateDisplayNameModal from "../events/modal/updateDisplayNameModal";
import TopNav from "./TopNav";
// import FloatingMenu from "./FloatingMenu";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import GetInfoById from "../events/common/GetInfoById";
import { decryptText, encryptText } from "./Encryptor";
import VideoModal from "../events/modal/AdvertisementModal";
import { useModal } from "src/_common/hooks/custom/useModal";
import LandingPageRedirection from "./LandingPageRedirection";
import { useSocketChannel } from "src/_common/hooks/custom/useSocketChannel";
import {
  useAppGuestUserIdSelector,
  useAppUserDetailsSelector,
  useAppUserTokenSelector,
} from "src/_common/hooks/selectors/userSelector";
import StatusModal from "../events/modal/statusModal";
import SocketImplementations from "./SocketImplementations";
import GuestSaveVoteModal from "../events/modal/guestSaveVoteModal";
// import VideoModal from "../events/modal/videoModal";

import queryString from "query-string";

function Sidebar({ page }: any) {
  const gameDetails = useAppGameDetailsSelector();
  const { rodeoEventId, performanceId, eventId } = useParams<any>();
  const eventAction = useAppEventAction();
  const [url, setUrl] = useState<any>("");
  const [promoType, setPromoType] = useState<any>("");
  const { showModal, toggleShowModal } = useModal();
  const userApi = useUserApi();
  const userAction = useAppUserAction();
  const location = useLocation();
  // const rodeoEventDetails = useAppRodeoEventDetailsSelector();
  const userDetails = useAppUserDetailsSelector();
  const couponDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.COUPON);
  const appRedirectInfoFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.APP_REDIRECT);
  const userToken = useAppUserTokenSelector();
  const history = useHistory();
  const performanceEndDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.END_ALL_EVENT);
  const guestUserId = useAppGuestUserIdSelector();

  const closeVideoModal = () => {
    localStorage.setItem("loginPromoVidSeen", "1");
    setTimeout(() => toggleShowModal(MODAL_NAME.VIDEO, false), 500);
  };

  const onAppRedirectModalSuccess = () => {
    if (appRedirectInfoFromSocket) {
      toggleShowModal(MODAL_NAME.STATUS, false);
      const link = appRedirectInfoFromSocket?.pwa_link;
      if (link) {
        setTimeout(() => {
          window.open(
            link +
              (appRedirectInfoFromSocket?.rodeo_event_id && userToken
                ? `#token=${encryptText(appRedirectInfoFromSocket?.rodeo_event_id + "")}&userToken=${userToken}`
                : appRedirectInfoFromSocket?.rodeo_event_id
                  ? `#token=${encryptText(appRedirectInfoFromSocket?.rodeo_event_id + "")}`
                  : userToken
                    ? `#userToken=${userToken}`
                    : ""),
            "_blank",
          );
        }, 500);
      }
    }
  };

  const closeGuestSaveVoteModal = () => {
    userAction.setPickIds(null);
    userAction.setGuestUserId(null);
    history.push(URLS.HOME);
  };

  useEffect(() => {
    if (userDetails && !userDetails.display_name) {
      toggleShowModal(MODAL_NAME.UPDATE_DISPLAY_NAME, true);
    }
  }, []);

  // useEffect(() => {
  //   const elem: any = document.getElementsByClassName("main-container")[0];
  //   if (elem) {
  //     if (
  //       (rodeoEventId && rodeoEventDetails?.game_info?.enable_header != 1) ||
  //       [RODEO_PAGE_NAME.RODEO_EVENTS, RODEO_PAGE_NAME.GROUPS].includes(page)
  //     ) {
  //       elem.style.paddingTop = "15px";
  //     } else {
  //       elem.style.paddingTop = "80px";
  //     }
  //   }
  // }, [rodeoEventDetails]);

  useEffect(() => {
    localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);

    const parsedHash = queryString.parse(location.hash);
    // console.log("parsedHash", parsedHash);
    if (parsedHash && parsedHash.userToken && parsedHash.userToken != "null") {
      // localStorage.setItem("parshedHash", "1");
      // userAction.resetGuestUserId();
      // localStorage.removeItem("guestUserId");
      const userToken = Array.isArray(parsedHash.userToken) ? parsedHash.userToken[0] : parsedHash.userToken;
      localStorage.setItem(STORAGE, userToken);
      userApi.callGetMe(
        null,
        (_message: string, _resp: any) => {
          // Success callback - no action needed
        },
        (_message: string) => {
          userAction.logout();
        },
      );
    }
  }, []);

  useEffect(() => {
    const x = localStorage.getItem("loginPromoVidSeen");
    if (page == RODEO_PAGE_NAME.LOGIN && gameDetails?.promotional_video_image && x != "1") {
      const vid = gameDetails?.promotional_video_image;
      const type = vid?.file_mime.substring(0, vid?.file_mime?.indexOf("/"));
      setPromoType(type);
      setUrl(vid?.original);
      if (type == "video" || type == "image") {
        toggleShowModal(MODAL_NAME.VIDEO, true);
      }
    }
  }, [page, gameDetails]);

  useEffect(() => {
    if (!rodeoEventId) eventAction.rodeoEventDetails(null);
    if (!performanceId) eventAction.performanceDetails(null);
    if (!eventId) eventAction.eventDetails(null);
  }, [rodeoEventId, performanceId, eventId]);

  useEffect(() => {
    if (couponDataFromSocket) toggleShowModal(MODAL_NAME.COUPON, true);
  }, [couponDataFromSocket]);

  useEffect(() => {
    if (appRedirectInfoFromSocket && appRedirectInfoFromSocket?.slug != APPLICATION_GLOBAL_SLUG) {
      toggleShowModal(MODAL_NAME.STATUS, true);
    }
  }, [appRedirectInfoFromSocket]);

  useEffect(() => {
    if (performanceEndDataFromSocket) {
      if (guestUserId) {
        toggleShowModal(MODAL_NAME.GUEST_SAVE_VOTE, true);
      }
    }
  }, [performanceEndDataFromSocket, guestUserId]);

  return (
    <React.Fragment>
      <SocketImplementations />

      {rodeoEventId && (
        <GetInfoById type="RE" id={decryptText(rodeoEventId + "")} setItemDetails={eventAction.rodeoEventDetails} />
      )}

      {performanceId && (
        <GetInfoById type="P" id={decryptText(performanceId + "")} setItemDetails={eventAction.performanceDetails} />
      )}

      {eventId && <GetInfoById type="E" id={decryptText(eventId + "")} setItemDetails={eventAction.eventDetails} />}

      <LandingPageRedirection page={page} />

      <TopNav page={page} />

      {/* <FloatingMenu page={page} /> */}

      {url && showModal && showModal[MODAL_NAME.VIDEO] && promoType && (
        <VideoModal onClose={closeVideoModal} url={url} shouldShow={showModal[MODAL_NAME.VIDEO]} type={promoType} />
      )}

      {showModal && showModal[MODAL_NAME.GUEST_SAVE_VOTE] && (
        <GuestSaveVoteModal
          onClose={closeGuestSaveVoteModal}
          onSuccess={() => history.push(URLS.AUTH.LOGIN)}
          shouldShow={showModal[MODAL_NAME.GUEST_SAVE_VOTE]}
        />
      )}

      {showModal && showModal[MODAL_NAME.STATUS] && appRedirectInfoFromSocket && (
        <StatusModal
          shouldShow={showModal[MODAL_NAME.STATUS]}
          onClose={() => toggleShowModal(MODAL_NAME.STATUS, false)}
          onSuccess={onAppRedirectModalSuccess}
          message={appRedirectInfoFromSocket?.name + " has been started. Do you want to switch?"}
          type={2}
        />
      )}

      {showModal && showModal[MODAL_NAME.UPDATE_DISPLAY_NAME] && (
        <UpdateDisplayNameModal
          onClose={() => toggleShowModal(MODAL_NAME.UPDATE_DISPLAY_NAME, false)}
          shouldShow={showModal[MODAL_NAME.UPDATE_DISPLAY_NAME]}
        />
      )}

      {showModal &&
        showModal[MODAL_NAME.COUPON] &&
        couponDataFromSocket &&
        couponDataFromSocket.image &&
        (couponDataFromSocket.type == 1 || (couponDataFromSocket.type == 2 && userDetails?.id)) && (
          <CouponModal
            shouldShow={showModal[MODAL_NAME.COUPON]}
            onClose={() => toggleShowModal(MODAL_NAME.COUPON, false)}
            image={couponDataFromSocket.image}
          />
        )}
    </React.Fragment>
  );
}

export default Sidebar;
